module.exports = __webpack_public_path__ + "fonts/HalisR-Light.db42a95f.otf";